import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';
import { ACCOUNT_STATUS_COPY } from '../constants/accountConstants';

export function isHubAccountActive(account) {
  return account?.is_active !== false;
}

export default function BusinessFunctionCard({
  account,
  canToggle = false,
  isToggling = false,
  showOrganisation = false,
  onOpen,
  onToggle,
  styles,
}) {
  const isActive = isHubAccountActive(account);
  const title = account?.name || account?.account_name || account?.account_id;
  const organisationName = account?.organisation_name || account?.organisation?.name || '';

  return (
    <Card
      variant="outlined"
      sx={!isActive ? styles?.hubCardInactive : undefined}
    >
      <CardActionArea onClick={() => onOpen?.(account)}>
        <CardContent>
          <Box sx={styles?.hubCardHeaderRow}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle1" fontWeight={600} noWrap title={title}>
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {account?.account_id}
              </Typography>
              {showOrganisation && organisationName ? (
                <Typography variant="caption" color="text.secondary" noWrap title={organisationName}>
                  {organisationName}
                </Typography>
              ) : null}
              {!isActive ? (
                <Typography variant="caption" color="text.secondary">
                  {ACCOUNT_STATUS_COPY.inactive}
                </Typography>
              ) : null}
            </Box>

            {canToggle ? (
              <Box
                sx={styles?.hubCardToggle}
                onClick={(event) => event.stopPropagation()}
                onMouseDown={(event) => event.stopPropagation()}
              >
                <FormControlLabel
                  sx={{ mr: 0 }}
                  onClick={(event) => event.stopPropagation()}
                  control={
                    <Switch
                      size="small"
                      checked={isActive}
                      disabled={isToggling}
                      onChange={(event) => {
                        event.stopPropagation();
                        onToggle?.(account, event.target.checked);
                      }}
                      inputProps={{
                        'aria-label': isActive
                          ? ACCOUNT_STATUS_COPY.active
                          : ACCOUNT_STATUS_COPY.inactive,
                      }}
                    />
                  }
                  label={isActive ? ACCOUNT_STATUS_COPY.active : ACCOUNT_STATUS_COPY.inactive}
                />
              </Box>
            ) : null}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
